import { CommonModule } from '@angular/common';
import { Component, Signal, effect, input } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import {
    BusinessProcessTask,
    BusinessProcessTaskDataInterface,
    OrganisationStructure,
    System,
} from 'app/api';
import { OrgService } from 'app/modules/org-sys-area/services/org.service';
import { ViewService } from 'app/modules/view/view.service';
import { NewMDOService } from 'app/services/new_mdo.service';
import { interfaceValues } from '../../../maintain-interface-components/interface-values';
import { BpReportService } from 'app/modules/bp-report/bp-report.service';

@Component({
    selector: 'data-view-mode',
    imports: [CommonModule, TranslocoModule],
    templateUrl: './data-view-mode.component.html',
    styleUrl: './data-view-mode.component.scss',
})
export class DataViewModeComponent {
    private _oldModel: BusinessProcessTask;
    model: Signal<BusinessProcessTask> = input();
    showHeader: Signal<boolean> = input();

    service: Signal<ViewService | BpReportService> = input();
    valueProp: Signal<string> = input();

    private _responsible: string;
    private _technology: string;
    private _transaction: string;

    constructor(
        private mdoService: NewMDOService,
        private orgService: OrgService
    ) {
        effect(() => {
            if (this.model()) {
                if (this._oldModel && this._oldModel.id !== this.model().id) {
                    this._responsible = null;
                    this._technology = null;
                    this._transaction = null;
                }
                this._oldModel = structuredClone(this.model());
            }
        });
    }

    findDeep(labelToFind: string, valueToFind: string, objects: any[]): any | null {
        if (!objects || !objects.length) {
            return null;
        }
        for (let index = 0; index < objects.length; index++) {
            const element = objects[index];
            if (element[labelToFind] === valueToFind) {
                return element;
            }

            if (element.children && element.children.length) {
                const result = this.findDeep(labelToFind, valueToFind, element.children);
                if (result) {
                    return result;
                }
            }
        }
        return null;
    }

    get responsible(): string {
        if (!this._responsible) {
            const responsible: OrganisationStructure = this.findDeep(
                this.valueProp(),
                this.model().data.action.responsible,
                this.orgService.state()
            );

            if (responsible) {
                this._responsible = responsible.title;
            }
        }
        return this._responsible;
    }

    get technology(): string {
        if (!this._technology) {
            const technology: System = this.findDeep(
                this.valueProp(),
                this.model().data.action.system,
                this.mdoService.systems()
            );
            if (technology) {
                this._technology = technology.title;
            }
        }
        return this._technology;
    }

    get transaction(): string {
        if (!this._transaction) {
            const data: any = this.model().data.info;

            if (data?.tcode) {
                this._transaction = data.tcode + ' - ' + data.name;
            } else {
                this._transaction = null;
            }
        }
        return this._transaction;
    }

    getDependency(id: string): string {
        const task = this.service()
            .model()
            .tasks.find((bp: BusinessProcessTask) => bp.id === id);

        if (task) {
            return `<b>${task.data.action.title1}</b> - ${task.data.action.title2}`;
        }
        return 'N/A';
    }

    getEntry(input: BusinessProcessTaskDataInterface): string {
        const category = interfaceValues.find(value => value.value === +input.category);
        return `<b>${category.label}</b> - ${input.description}`;
    }

    trackByFn(index: number, item: any): any {
        return item || index;
    }
}
